import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { COMPANY, SERVICES, AREAS } from "@/data/site";
import { Logo } from "@/components/Logo";

const Footer = () => (
  <footer className="bg-navy-deep text-white">
    <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
      <div>
        <Logo dark />
        <p className="mt-5 text-sm leading-relaxed text-white/70">
          Bathroom, kitchen and flooring remodeling for Huntsville, Madison, Athens and the surrounding Alabama counties. Licensed, insured, and built to last.
        </p>
      </div>

      <nav aria-label="Footer services">
        <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-salmon-vibrant">Services</h3>
        <ul className="mt-4 space-y-2.5">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/${s.slug}`}
                data-testid={`footer-link-${s.slug}`}
                className="text-sm text-white/80 transition-colors hover:text-salmon-vibrant"
              >
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="Footer service areas">
        <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-salmon-vibrant">Service Areas</h3>
        <ul className="mt-4 space-y-2.5">
          {AREAS.map((a) => (
            <li key={a.slug}>
              <Link
                to={`/service-areas/${a.slug}`}
                data-testid={`footer-link-area-${a.slug}`}
                className="text-sm text-white/80 transition-colors hover:text-salmon-vibrant"
              >
                {a.name}, AL
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-salmon-vibrant">Contact</h3>
        <ul className="mt-4 space-y-3 text-sm text-white/80">
          <li>
            <a href={COMPANY.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 transition-colors hover:text-salmon-vibrant">
              <Phone className="h-4 w-4 shrink-0" /> {COMPANY.phone}
            </a>
          </li>
          <li>
            <a href={`mailto:${COMPANY.email}`} data-testid="footer-email-link" className="flex items-center gap-2 transition-colors hover:text-salmon-vibrant">
              <Mail className="h-4 w-4 shrink-0" /> {COMPANY.email}
            </a>
          </li>
          <li className="flex items-center gap-2">
            <MapPin className="h-4 w-4 shrink-0" /> {COMPANY.city}
          </li>
          <li className="flex items-center gap-2">
            <Clock className="h-4 w-4 shrink-0" /> {COMPANY.hours}
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-5 text-xs text-white/50 sm:flex-row lg:px-10">
        <p>© {new Date().getFullYear()} {COMPANY.fullName}. All rights reserved.</p>
        <p>Licensed & Insured · Free Estimates · Huntsville, Alabama</p>
      </div>
    </div>
  </footer>
);

export default Footer;
